import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 1475 544.4"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "svg-UT-logo_svg__a" }, [
        _createElementVNode("path", {
          d: "M0 0h1475v544.4H0z",
          style: {"fill":"none"}
        })
      ])
    ], -1),
    _createElementVNode("g", { style: {"clip-path":"url(#svg-UT-logo_svg__a)"} }, [
      _createElementVNode("path", {
        d: "M520.1 34.5v104.3h-54.4v61.7h54.4v222.6c0 78.6 26.4 110.2 105.1 110.2h29.4v-63.2h-5.1c-34.5 0-47-13.2-47-47.8V200.6h63.9v-61.7h-63.9V34.5h-82.4ZM213.8 465.8c-81.5 0-124.9-49.2-124.9-159.4V0H0v299.7c0 173.4 73.5 244.6 213.8 244.6S428.3 473 428.3 299.7V0h-88.9v306.4c0 110.2-44.1 159.4-125.6 159.4M1192.3 0h-85.2v82.3h85.2V0Zm0 138.9h-85.2v394.5h85.2V138.9Zm282.6-5.9c-2.9-1.5-11-3.7-20.6-3.7-58 0-92.6 34.5-112.4 77.1v-67.6h-80.1v394.5h83V315.9c0-66.1 33.1-97.7 99.2-97.7h30.9V133ZM953.6 343.8v25.7c0 63.9-52.2 109.5-113.9 109.5-35.3 0-66.1-20.6-66.1-55.8 0-33.1 27.9-58.8 76.4-65.4l103.6-14ZM818.4 544.4c69.1 0 115.3-27.2 141.1-66.1v55.1h77.1V304.9c0-152.8-82.3-182.2-167.5-182.2-110.2 0-162.4 61-168.2 137.4h87.4c5.9-44.8 38.2-72 82.3-72 46.3 0 83 26.4 83 99.2L828 299.8c-119.7 11.8-146.9 73.5-146.9 123.4-.1 76.4 60.9 121.2 137.3 121.2",
        style: {"fill":"#003594"}
      })
    ], -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "UT-logo"}) } }